import { Suspense } from 'react'

import { Layout as AntLayout } from 'antd'
import { Outlet } from 'react-router-dom'
import styled from 'styled-components'

import { Header } from '../components/header'

const StyledLayout = styled(AntLayout)`
  width: 100vw;
  min-height: 100vh;
  box-sizing: border-box;
`

export const Layout = () => {
  return (
    <StyledLayout>
      <Header />
      <div style={{ flexGrow: '1', display: 'flex' }}>
        <div
          style={{ flexGrow: '1', display: 'flex', flexDirection: 'column' }}
        >
          <Suspense fallback={<div>Loading...</div>}>
            <Outlet />
          </Suspense>
        </div>
      </div>
    </StyledLayout>
  )
}
